// extracted by mini-css-extract-plugin
module.exports = {"validation":"recorder-search-region-selector_validation_12Jf4","validation_container":"recorder-search-region-selector_validation_container_3nDis"};